module.exports = "/images/vendor/flag-icon-css/flags/4x3/dj.svg?423c41561146de8c3017bbe35919e0bd";